// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import type { Location, Match, RouterHistory } from 'react-router-dom'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import HesburgerPage from './HesburgerPage/HesburgerPage'
import KitchenPage from './KitchenPage/KitchenPage'
import ManagerPage from './ManagerPage/ManagerPage'
import MarketPage from './MarketPage/MarketPage'
import RestaurantPage from './RestaurantPage/RestaurantPage'
import css from './weeklyInfoRoot.css'
const TABS = {
  MANAGER: 'liikennemyymalapaallikko',
  RESTAURANT: 'ravintola',
  KITCHEN: 'keittio',
  MARKET: 'market',
  HESBURGER: 'hesburger',
}
type WeeklyInfoRootProps = {
  history: RouterHistory
  location: Location
  match: Match
}

class WeeklyInfoRoot extends React.PureComponent<WeeklyInfoRootProps> {
  getTabs = () => [
    {
      label: i18n.t('weeklyInfo.tab.manager'),
      value: TABS.MANAGER,
    },
    {
      label: i18n.t('weeklyInfo.tab.restaurant'),
      value: TABS.RESTAURANT,
    },
    {
      label: i18n.t('weeklyInfo.tab.kitchen'),
      value: TABS.KITCHEN,
    },
    {
      label: i18n.t('weeklyInfo.tab.market'),
      value: TABS.MARKET,
    },
    {
      label: i18n.t('weeklyInfo.tab.hesburger'),
      value: TABS.HESBURGER,
    },
  ]
  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[parts.length - 2] || TABS.MANAGER
  }
  onTabClick = (tab) => {
    const parts = this.props.location.pathname.split('/')
    const week = parts.length === 4 ? parts[3] : undefined
    const target = [this.getBasePath(), tab.value]
    this.props.history.push((week ? [...target, week] : target).join('/'))
  }
  getBasePath = () => this.props.location.pathname.split('/').slice(0, 2).join('/')

  render() {
    const { match } = this.props
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('weeklyInfo.title.page')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('weeklyInfo.title.page')}</Typography>
          <Switch>
            <Route path={`${match.path}/${TABS.MARKET}/:week`} component={MarketPage} />
            <Route exact path={`${match.path}/${TABS.MARKET}`} component={MarketPage} />
            <Route path={`${match.path}/${TABS.KITCHEN}/:week`} component={KitchenPage} />
            <Route exact path={`${match.path}/${TABS.KITCHEN}`} component={KitchenPage} />
            <Route path={`${match.path}/${TABS.RESTAURANT}/:week`} component={RestaurantPage} />
            <Route exact path={`${match.path}/${TABS.RESTAURANT}`} component={RestaurantPage} />
            <Route path={`${match.path}/${TABS.HESBURGER}/:week`} component={HesburgerPage} />
            <Route exact path={`${match.path}/${TABS.HESBURGER}`} component={HesburgerPage} />
            <Route path={`${match.path}/${TABS.MANAGER}/:week`} component={ManagerPage} />
            <Route exact path={`${match.path}/${TABS.MANAGER}`} component={ManagerPage} />
            <Redirect to={`${match.path}/${TABS.MANAGER}`} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(WeeklyInfoRoot)
